export enum RecaptchaActions {
  AccountCreation = 'ACCOUNT_CREATION',
  LoginPage = 'login_page',
}
